import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-object-modify',
  templateUrl: './object-modify.component.html',
  styleUrls: ['./object-modify.component.css']
})
export class ObjectModifyComponent implements OnInit {

  editForm: any | FormGroup;
  allTemplates: any= []
  singleTemplate: any = []
  objectTemplateId = ""
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  objectid: any = "";
  cid:any

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getAllObjectTemplate()
    this.editForm = this.fb.group({
      description: [''],
      name: [''],
      type: [''],
      group: [''],
      id: [''],
      objectTemplateId: [''],
      nameValue:this.fb.array([])
    }) 
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllObjectTemplate();
  }
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllObjectTemplate();
  }

  get objectArr(){
    return this.editForm.get('nameValue') as FormArray;
  }

  nameValue(){
    return this.fb.group({
      "key": ['']
    })
  }
  
  addNameValue(){
  this.objectArr.push(this.nameValue())
  }

  removeNameValue(index: number){
  this.objectArr.removeAt(index)
  }

  updateObjectTemplate(){
    let body = {
      "id": this.editForm.get('id').value,
      "version": 0,
      "isActive": true,
      "description":  String(this.editForm.get('description').value),
      "objectTemplateId": Number(this.editForm.get('objectTemplateId').value),
      "name":  String(this.editForm.get('name').value),
      "type":  String(this.editForm.get('type').value),
      "group":  String(this.editForm.get('group').value),
      "nameValue": this.editForm.get('nameValue').value,
      "cid": Number(this.cid)
    }
    console.log(body)
    this.generic_service.updateObjectTemplate(body).subscribe(
      (response:any)=>{
        console.log(response)
        // this.editForm.reset()
        this.getAllObjectTemplate()
        this.toastr.success("Successfully Updated")
        this.cancelModel()
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  getAllObjectTemplate(){
    this.generic_service.getAllObjectTemplate().subscribe(
      (response:any)=>{
        console.log(response)
        this.allTemplates = response.response
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton2")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getObjectTemplateById(id:any){
    this.objectid = id
    this.editForm.reset()
    this.objectArr.clear()

    this.generic_service.getObjectTemplateById(id).subscribe(
      (response:any)=>{
        console.log(response)
        this.editForm.patchValue({
          name: response.response.name,
          type: response.response.type,
          description: response.response.description,
          group: response.response.group,
          objectTemplateId: response.response.objectTemplateId,
          id: response.response.id
        })
        for(var i=0; i<response.response.nameValue.length; i++){
          let obj = this.fb.group({
            "key":[response.response.nameValue[i].key]
          })
          this.objectArr.push(obj)
        }

      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

 

}